import React from 'react'
import { Link } from "react-router-dom";


const Gynaecology = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>प्रसूति और स्त्री रोग</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                <li className="breadcrumb-item">प्रसूति और स्त्री रोग</li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा </span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>

      <section className="content-inner" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Gynecology_01.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Gynecology_02.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Gynecology_03.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Gynecology_04.webp" alt="/" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-inner service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 single-inner order-lg-1">
              <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                <img src="./assets/img/Gynaecology.webp" alt className="object-fit-cover" />
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <h2>प्रसूति एवं स्त्री रोग</h2>
                <p>ओमकार मल्टीस्पेशलिटी हॉस्पिटल का गायनेकोलॉजी डिपार्टमेंट एक बड़ी यूनिट है जो महिलाओं की रिप्रोडक्टिव और गायनेकोलॉजिकल ज़रूरतों के लिए सभी सर्विस पूरी तरह से, ध्यान से और पक्के इरादे से देती है। ऑब्सटेट्रिक्स और गायनेकोलॉजी सेक्शन प्रेग्नेंसी, मेनोपॉज़ और ज़िंदगी के दूसरे पड़ावों में महिलाओं को सपोर्ट करने के लिए हमेशा तैयार रहता है।</p>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ पेट और वजाइनल हिस्टेरेक्टॉमी</li>
                  <li>  ✅ हिस्टेरोस्कोपी</li>
                  <li>  ✅ मेनोपॉज़ल लक्षणों का इलाज</li>
                  <li>  ✅ नॉर्मल और हाई-रिस्क प्रेग्नेंसी</li>
                  <li>  ✅ नॉर्मल और बिना दर्द वाली डिलीवरी</li>
                  <li>  ✅ सिजेरियन सेक्शन</li>
                  <li>  ✅ इनफर्टिलिटी</li>
                  <li>  ✅ यूटेरस/ओवेरियन कैंसर का इलाज</li>
                  <li>  ✅ इर्रेगुलर पीरियड्स</li>
                  <li>  ✅ फाइब्रॉएड</li>
                </ul>

                <h3>हमारी प्रसूति सेवाएँ (गर्भावस्था की देखभाल)</h3>
                <b style={{ color: "black" }}>1. गर्भावस्था से पहले की काउंसलिंग</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ प्रजनन क्षमता संबंधी मार्गदर्शन</li>
                  <li>  ✅ गर्भधारण से पहले स्वास्थ्य की जाँच</li>
                  <li>  ✅ आनुवंशिक परामर्श</li>
                </ul>
                <b style={{ color: "black" }}>2. प्रसव-पूर्व (Antenatal) देखभाल</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ गर्भावस्था के दौरान नियमित जाँच</li>
                  <li>  ✅ अल्ट्रासाउंड और भ्रूण की निगरानी</li>
                  <li>  ✅ पोषण और जीवनशैली संबंधी मार्गदर्शन</li>
                  <li>  ✅ जटिलताओं की जाँच (स्क्रीनिंग)</li>
                </ul>
                <b style={{ color: "black" }}>3. उच्च-जोखिम वाली गर्भावस्था का प्रबंधन</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ गर्भावस्था में मधुमेह (डायबिटीज़)</li>
                  <li>  ✅ उच्च रक्तचाप (हाई ब्लड प्रेशर)</li>
                  <li>  ✅ एकाधिक गर्भधारण (जुड़वाँ बच्चे, आदि)</li>
                  <li>  ✅ अधिक उम्र में गर्भधारण की देखभाल</li>
                </ul>
                <b style={{ color: "black" }}>4. प्रसव और डिलीवरी</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ सामान्य योनि प्रसव (Normal delivery)</li>
                  <li>  ✅ सीज़ेरियन सेक्शन (C-section)</li>
                  <li>  ✅ आपातकालीन प्रसूति देखभाल</li>
                </ul>
                <b style={{ color: "black" }}>5. प्रसव-पश्चात देखभाल</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ माँ के स्वास्थ्य-लाभ की निगरानी</li>
                  <li>  ✅ स्तनपान में सहायता</li>
                  <li>  ✅ डिलीवरी के बाद स्वास्थ्य की जाँच</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 m-b30">
              <aside className="side-bar sticky-top left">
                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                  <div className="widget-title">
                    <h4 className="title">सभी सेवाएँ</h4>
                  </div>
                  <ul>
                    <li className="active"><Link to="/gynaecology">प्रसूति एवं स्त्री रोग</Link></li>
                    <li ><Link to="/dental">डेंटल</Link></li>
                    <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                    <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                    <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                    <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                    <li ><Link to="/urology">यूरोलॉजी</Link></li>
                    <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                    <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                    <li><Link to="/ent">कान, नाक और गले</Link></li>
                    <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                    <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                    <li><Link to="/paediatrics">पीडियाट्रिक्स</Link></li>
                  </ul>
                </div>
                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                  <div className="widget-content">
                    <img src="./assets/images/question.png" width={80} alt />
                    <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                    <div className="phone-number">
                      <a href="tel:+919165155945">+91 9165155945</a>
                    </div>
                    <div className="email">
                      <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                        @gmail.com</a>
                    </div>
                    <div className="link-btn">
                      <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                        Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default Gynaecology